import React from 'react'
import { HeroIcons } from '../lib/utils/heroIcons'

type IconFromStringProps = {
  iconName: string
  className?: string
}

export default function IconFromString({
  iconName,
  className,
}: IconFromStringProps) {
  const Icon = HeroIcons[iconName as keyof typeof HeroIcons]

  if (Icon) {
    return <Icon className={className} />
  }
  return <></>
}
